import {DropTargetMonitor } from 'react-dnd'
import {getRepoforId} from '../../utils/getRepoforId'
import {showConfirmModal} from '../../actions/modals'
import store from '../../store'



function onDrop(props,droppedItem,multiselectItems) {	
	let promises=[]
	if(multiselectItems){	
		Object.keys(multiselectItems).map((key)=>{
			const item=multiselectItems[key]
			promises.push(props.moveToRepo(item,props.repo.id))
			return null

		})
	}else{
		promises.push(props.moveToRepo(droppedItem,props.repo.id))
	}

	Promise.all(promises).then(function(response) {
		let itemCount=1
		if(multiselectItems){
			itemCount=Object.keys(multiselectItems).length
		}
		let notificationMessage=''
		if(itemCount>1){
			 notificationMessage=`${itemCount} items to ${props.repo.name}`
		}else{
			notificationMessage=`${droppedItem.name || droppedItem.body} to ${props.repo.name}`
		}

		props.showNotification(notificationMessage,'Moved','default')
		if(props.hideModal){
			props.hideModal()	
		}

	})

}






const RepoTarget = {
	canDrop(props: props, monitor: DropTargetMonitor) {
		const repo = props.repo
		const draggedItem=monitor.getItem().cellItem
		const containingRepo = getRepoforId(draggedItem.repo)
		if(containingRepo && (containingRepo.role ==='viewer' || containingRepo.role ==='consumer')){
			return false
		}
		else if(draggedItem.repo === repo.id){
			if(!draggedItem.folder && !draggedItem.parent){
				return false
			}else{
				return true
			}			
		}
		else if(repo.disabled){
			return false
		}
		else if(repo.joined && (repo.role === 'editor' || repo.role === 'admin' || repo.role === 'author')){
			return true
		}else{
			return false
		}
		
	},
	drop(props: props, monitor: DropTargetMonitor) {
		const droppedItem=monitor.getItem().cellItem
		const multiselectItems=monitor.getItem().multiselectItems
		const inSharedRepo=monitor.getItem().inSharedRepo
		const inPublishedRepo=monitor.getItem().inPublishedRepo
		if(inSharedRepo){
			store.dispatch(showConfirmModal(multiselectItems,onDrop.bind(this,props,droppedItem,multiselectItems),'moveFromSharedRepo'))
		}else if(inPublishedRepo && droppedItem.repo !=props.repo.id){
			store.dispatch(showConfirmModal(multiselectItems,onDrop.bind(this,props,droppedItem,multiselectItems),'moveFromPublishedRepo'))
		}

		else{
			onDrop(props,droppedItem,multiselectItems)
		}

		
	}
}

export default RepoTarget

